import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '~/chords';
import { Icon } from '~/components';
import { Header } from '~settings/components/Header';
import { SETTINGS_ROUTES } from '~settings/config/routes.ts';

export function SublabelRequestHeader() {
  const { t } = useTranslation('settings');

  return (
    <Header
      breadcrumbs={
        <Breadcrumbs.Root>
          <Breadcrumbs.Item to={SETTINGS_ROUTES.ROOT}>
            <Icon type="gear" size="sm" variant="regular" className="mr-sm" />
            {t('title')}
          </Breadcrumbs.Item>
          <Breadcrumbs.Item to={SETTINGS_ROUTES.LABEL_LIST}>
            {t('labels')}
          </Breadcrumbs.Item>
          <Breadcrumbs.Item>
            {t('sublabelRequest.requestTitle')}
          </Breadcrumbs.Item>
        </Breadcrumbs.Root>
      }
      className="pb-lg"
    >
      <div className="flex flex-col gap-sm text-strong-on-dark">
        <h1 className="text-display-sm">{t('sublabelRequest.requestTitle')}</h1>
        <p>{t('sublabelRequest.requestDescription')}</p>
      </div>
    </Header>
  );
}
SublabelRequestHeader.displayName = 'SublabelRequestHeader';
